import BURN_REDEEM_1155_V3_ABI from '@manifoldxyz/typed-contracts/abis/burnredeem/BURN_REDEEM_1155_V3_ABI.json';
import BurnRedeemExtensionContractCore from './burnRedeemExtensionCore';

export default class BurnRedeemExtensionContract1155V3 extends BurnRedeemExtensionContractCore {
  ABI = BURN_REDEEM_1155_V3_ABI;

  constructor(extensionContractAddress: string) {
    super(extensionContractAddress);
  }
}
